import React from "react";

import "./Badge.css";
class GoogleCaptchaBadge extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="badge">
                <div className="badge-text">
                    <span>
                        protected by <strong>reCAPTCHA</strong>
                    </span>
                    <div className="badge-pt">
                        <a
                            href="https://www.google.com/intl/en/policies/privacy/"
                            target="_blank"
                        >
                            Privacy
                        </a>
                        <span aria-hidden="true" role="presentation">
                            &nbsp;-&nbsp;
                        </span>
                        <a
                            href="https://www.google.com/intl/en/policies/terms/"
                            target="_blank"
                        >
                            Terms
                        </a>
                    </div>
                </div>
                <div className="badge-logo">
                    <div className="badge-logo-img"></div>
                </div>
            </div>
        );
    }
}

export default GoogleCaptchaBadge;
